export default "__VITE_ASSET__BcxAbqYV__"